export enum SHORT_LOCALES {
  en = 'en',
  de = 'de',
}

export enum FULL_LOCALES {
  en = 'en-US',
  de = 'de-DE',
}

export const DEFAULT_LOCALE_SHORT = SHORT_LOCALES.en
export const DEFAULT_LOCALE = FULL_LOCALES.en

export const SUPPORTED_LOCALES: ReadonlyArray<{
  short: SHORT_LOCALES
  full: FULL_LOCALES
  labelKey: string
}> = [
  { short: SHORT_LOCALES.en, full: FULL_LOCALES.en, labelKey: 'common.locale.en.label' },
  { short: SHORT_LOCALES.de, full: FULL_LOCALES.de, labelKey: 'common.locale.de.label' },
]

// Domain-scoped cookie so cockpit on app.* and auth-ui on auth.* converge on
// the same value once cockpit's switcher mirrors it.
// MUST mirror config/server/locale.js (LOCALE_COOKIE_NAME, SUPPORTED,
// DEFAULT_SHORT, parseShort). tests/server/locale-parity.test.mts pins both.
//
// TODO(security): prefix with `__Secure-` once cockpit is on the same name.
// Browsers only accept `__Secure-`-prefixed cookies set over HTTPS and require
// the Secure attribute — defence-in-depth against MITM-injection from any
// non-HTTPS `.paretos.com` subdomain (none today, but architectural future-
// proofing). `__Host-` is NOT applicable because we need Domain= for
// cross-subdomain sharing with cockpit. Renaming requires a coordinated
// cockpit + auth-ui release because both sides read/write this exact name.
export const LOCALE_COOKIE_NAME = 'paretos_lang'
export const LOCALE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

// `window.__PARETOS_LOCALE__` is injected by server.js' SPA fallback after it
// resolves Accept-Language / cookie / ?lang= server-side. Type the global so
// readers don't have to cast.
declare global {
  interface Window {
    __PARETOS_LOCALE__?: string
  }
}

const SHORT_TO_FULL: Record<SHORT_LOCALES, FULL_LOCALES> = {
  [SHORT_LOCALES.en]: FULL_LOCALES.en,
  [SHORT_LOCALES.de]: FULL_LOCALES.de,
}

export const shortToFull = (s: SHORT_LOCALES): FULL_LOCALES => SHORT_TO_FULL[s]

export const parseShortLocale = (raw: string | null | undefined): SHORT_LOCALES | null => {
  if (!raw) {
    return null
  }
  // Trim before split so a stray ' en' (paste, mishandled cookie write, …)
  // resolves cleanly instead of silently dropping to default.
  const head = raw.trim().toLowerCase().split('-')[0]
  if (head === SHORT_LOCALES.de) {
    return SHORT_LOCALES.de
  }
  if (head === SHORT_LOCALES.en) {
    return SHORT_LOCALES.en
  }
  return null
}
